// PushNotificationsSection.jsx
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./PushNotificationsSection.css";
import analyticsService from "../../../services/analyticsService";

function PushNotificationsSection() {
  const [pushData, setPushData] = useState({
    sent: { today: 0, yesterday: 0, week: 0, month: 0, lastMonth: 0 },
    opens: { today: 0, yesterday: 0, week: 0, month: 0, lastMonth: 0 },
    purchases: { today: 0, yesterday: 0, week: 0, month: 0, lastMonth: 0 },
    revenue: { today: 0, yesterday: 0, week: 0, month: 0, lastMonth: 0 },
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await analyticsService.getPushAnalytics();

        if (response.success && response.data) {
          const { pushMetrics, openMetrics, conversionMetrics, revenueMetrics } = response.data;

          setPushData({
            sent: {
              today: pushMetrics?.today || 0,
              yesterday: pushMetrics?.yesterday || 0,
              week: pushMetrics?.week || 0,
              month: pushMetrics?.month || 0,
              lastMonth: pushMetrics?.lastMonth || 0,
            },
            opens: {
              today: openMetrics?.today || 0,
              yesterday: openMetrics?.yesterday || 0,
              week: openMetrics?.week || 0,
              month: openMetrics?.month || 0,
              lastMonth: openMetrics?.lastMonth || 0,
            },
            purchases: {
              today: conversionMetrics?.today || 0,
              yesterday: conversionMetrics?.yesterday || 0,
              week: conversionMetrics?.week || 0,
              month: conversionMetrics?.month || 0,
              lastMonth: conversionMetrics?.lastMonth || 0,
            },
            revenue: {
              today: revenueMetrics?.today || 0,
              yesterday: revenueMetrics?.yesterday || 0,
              week: revenueMetrics?.week || 0,
              month: revenueMetrics?.month || 0,
              lastMonth: revenueMetrics?.lastMonth || 0,
            },
          });
        }
      } catch (error) {
        console.error("Error fetching push notification analytics:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <motion.div
      className="push-section"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      <div className="section-title">
        <h2>Push Notifications</h2>
        <span className="material-symbols-outlined">notifications_active</span>
      </div>
      <div className="push-analytics-grid">
        <div className="push-card">
          <h3>🔔 Sent</h3>
          <p><strong>Today:</strong> <span>{pushData.sent.today}</span></p>
          <p><strong>Yesterday:</strong> <span>{pushData.sent.yesterday}</span></p>
          <p><strong>Week:</strong> <span>{pushData.sent.week}</span></p>
          <p><strong>Month:</strong> <span>{pushData.sent.month}</span></p>
          <p><strong>Last Month:</strong> <span>{pushData.sent.lastMonth}</span></p>
        </div>

        <div className="push-card">
          <h3>👁️ Opens</h3>
          <p><strong>Today:</strong> <span>{pushData.opens.today}</span></p>
          <p><strong>Yesterday:</strong> <span>{pushData.opens.yesterday}</span></p>
          <p><strong>Week:</strong> <span>{pushData.opens.week}</span></p>
          <p><strong>Month:</strong> <span>{pushData.opens.month}</span></p>
          <p><strong>Last Month:</strong> <span>{pushData.opens.lastMonth}</span></p>
        </div>

        <div className="push-card">
          <h3>🛍️ Purchases</h3>
          <p><strong>Today:</strong> <span>{pushData.purchases.today}</span></p>
          <p><strong>Yesterday:</strong> <span>{pushData.purchases.yesterday}</span></p>
          <p><strong>Week:</strong> <span>{pushData.purchases.week}</span></p>
          <p><strong>Month:</strong> <span>{pushData.purchases.month}</span></p>
          <p><strong>Last Month:</strong> <span>{pushData.purchases.lastMonth}</span></p>
        </div>

        <div className="push-card">
          <h3>💵 Revenue (৳)</h3>
          <p><strong>Today:</strong> <span>{pushData.revenue.today}</span></p>
          <p><strong>Yesterday:</strong> <span>{pushData.revenue.yesterday}</span></p>
          <p><strong>Week:</strong> <span>{pushData.revenue.week}</span></p>
          <p><strong>Month:</strong> <span>{pushData.revenue.month}</span></p>
          <p><strong>Last Month:</strong> <span>{pushData.revenue.lastMonth}</span></p>
        </div>
      </div>
    </motion.div>
  );
}

export default PushNotificationsSection;
